<template>
  <div :class="getClassName()">
    <div class="step-item-row">
      <div class="step-item-row-image">
        <CustomIcon :name="item.icon" />
      </div>
      <div class="step-item-row-content">
        <div v-if="item.isActive">
          <p class="step-item-row-content-label">{{ item.label }}</p>
          <h3 class="step-item-row-content-title">{{ item.text }}</h3>
          <p :class="descriptionClass">{{ item.description }}</p>
        </div>
        <p v-else class="step-item-row-content-label">
          {{ item.label }}: {{ item.text }}
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import CustomIcon from "./CustomIcon.vue";
import classnames from "classnames";
export default {
  data() {
    return {
      // Had to store this to avoid linting error
      descriptionClass: "step-item-row-content-description",
    };
  },
  name: "step-item",
  components: { CustomIcon },
  props: {
    item: {
      type: Object,
      required: true,
      default: () => ({
        id: String,
        label: String,
        to: String,
        icon: String,
        text: String,
        description: String,
        isActive: Boolean,
        target_field: String,
        value: [String, Boolean, Array],
      }),
    },
  },
  methods: {
    getClassName() {
      const baseClass = "step-item";

      return classnames(baseClass, {
        ["is-active"]: this.item.isActive,
      });
    },
  },
};
</script>
